
const ProcessSection = () => {
  const steps = [
    {
      number: '01',
      title: 'Talk',
      description: 'We start with a confidential conversation about your business, your goals, and your timeline. No pressure, just honest discussion about your options.',
      details: ['Initial consultation', 'Business overview', 'Goal setting', 'Timeline discussion']
    },
    {
      number: '02',
      title: 'Evaluate',
      description: 'Our team conducts a thorough but respectful evaluation of your business, focusing on both financial performance and operational strengths.',
      details: ['Financial analysis', 'Operational review', 'Market assessment', 'Fair valuation']
    },
    {
      number: '03',
      title: 'Transition',
      description: 'If we move forward, we manage every detail of the transition process to ensure minimal disruption to your business and peace of mind for you.',
      details: ['Legal documentation', 'Employee communication', 'Customer transition', 'Ongoing support']
    }
  ];

  return (
    <section className="py-20 bg-soft-gray">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-playfair text-4xl font-bold text-navy mb-4">
            Our Simple 3-Step Process
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We've designed our process to be straightforward and stress-free, respecting both your time and your business.
          </p>
        </div>

        <div className="space-y-12">
          {steps.map((step, index) => (
            <div key={index} className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                <div className="flex items-center mb-4">
                  <span className="text-4xl font-bold text-[#C9A227] mr-4">{step.number}</span>
                  <h3 className="font-playfair text-3xl font-semibold text-navy">{step.title}</h3>
                </div>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  {step.description}
                </p>
                <ul className="space-y-2">
                  {step.details.map((detail, detailIndex) => (
                    <li key={detailIndex} className="flex items-center text-gray-600">
                      <i className="ri-check-line text-[#C9A227] mr-3"></i>
                      {detail}
                    </li>
                  ))}
                </ul>
              </div>
              <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                <div className="bg-white rounded-lg p-8 shadow-sm">
                  {/* Image removed */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
